import { SelectOptionProps } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import { ProductionCenterTypeEnum } from '../types';

export function useProductionCenterTypeOptions(): SelectOptionProps<ProductionCenterTypeEnum>[] {
  const { t } = useTranslation();

  return [
    {
      label: t('Portainer'),
      value: ProductionCenterTypeEnum.PORTAINER,
    },
  ];
}
